export function getApiBaseUrl() {
  const raw = (FRONTEND_API_BASE_URL || '').trim();
  const apiBase = raw.replace(/^"(.*)"$/, '$1').replace(/^'(.*)'$/, '$1').replace(/\/+$/, '');
  return apiBase;
}

export function buildApiUrl(path: string) {
  const base = getApiBaseUrl();
  if (!base) return path;
  if (!path) return base;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
